import React from "react"
import SlickSlider from "react-slick"
import { useMediaQuery } from "react-responsive"
import { getArticles, GetArticlesParams } from "../../helpers/get-articles"
import { BreakPoints } from "../../helpers/rwd"
import ArticlePreview from "../article-preview"
import { ArticlesListWrapper } from "./articles-list-elements"

interface ArticlesListProps {
  params: GetArticlesParams
  basePath: string
  layout?: "horizontal" | "vertical"
  className?: string
  showExcerpt?: boolean
}

const ArticlesList = ({
  params,
  basePath,
  layout = "horizontal",
  className = "",
  showExcerpt = true,
}: ArticlesListProps) => {
  const articles = getArticles(params)

  const isDesktop = useMediaQuery({
    query: `(max-width: ${BreakPoints.desktop}px)`,
  })
  const isTablet = useMediaQuery({
    query: `(max-width: ${BreakPoints.tablet}px)`,
  })
  const isSliderMode = isDesktop && layout === "vertical"

  const slidesToShow = Math.min(isSliderMode ? (isTablet ? 1 : 2) : 4, articles.length);

  return <ArticlesListWrapper className={`${layout} slider-mode`}>
    <SlickSlider
      arrows={false}
      dots={true}
      autoplay={false}
      slidesToShow={slidesToShow}
    >
      {articles &&
      articles.map((article, index) => (
        <ArticlePreview
          data={article}
          basePath={basePath}
          layout={layout}
          className={className}
          showExcerpt={showExcerpt}
          key={article.slug}
        />
      ))}
    </SlickSlider>
  </ArticlesListWrapper>;
}

export default ArticlesList
